var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D8EEF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 10L27 16.25h-6.25V10z",
    fill: "#028BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.75 10v6.25H27V27.5c0 1.379-1.121 2.5-2.5 2.5h-10c-1.38 0-2.5-1.121-2.5-2.5v-15a2.5 2.5 0 012.5-2.5h6.25z",
    fill: "#028BB7"
  })));
}

export default SvgFileCircle;